<template>

  <div id="bio">
    <div class="welcome">
      <p > ¡Welcome! 👋 </p>
    </div>
    <div id="content">
      <div class="grow-1">
        <div class="img-holder">
          <transition name="fade" mode="out-in">
            <img v-bind:key="imgUrl" class="img-circle" :src="imgUrl"/>
          </transition>
        </div>

        <div>
          <h1 class="title"> Marcos Pérez Rubio </h1>
          <p> <i> Bringing ideas to life through high quality software. </i> </p>
          <p> Software Engineer based in Barcelona / Madrid </p>
          <p> Full Stack Lover </p>
          <p> Bachelor on Computer Science </p>
          <p> Master on Big Data Management and Analytics </p>
        </div>
    </div>

    <div class="grow-1">
      <div style="text-align: left">
      <h2> Long story short </h2>
      <p>
        📚

        🏂

        ☕

        💻

        ✈️
      </p>

      <p> Currently: CTO at <a href="https://footanalytics.com" target="_blank"> Foot Analytics </a> </p>
      <p> Maker since 2014, I love building solutions from scratch</p>
      <p> Entrepreneur & freelance </p>

      <p> Agile & Devops culture </p>
      <h2> Say hello </h2>
      <p>
        I always enjoy having a chat, so don't hesitate and
        <a href="https://www.linkedin.com/in/marcospr/" target="_blank" > drop me a message</a>.
      </p>
      </div>
    </div>
    </div>
    <div class="services">
    <hr class="separator">
    <div >
      <h2 class="text-center"> What can I do for you </h2>
      <p class="text-center"> My <b> passion </b> is to <b> build, ship </b> and <b> improve </b> any kind of solution using <b> the right tool for the job </b>.</p>
      <p> Being a <i>full stack developer</i> for the last years has involved me in every aspect of lifecycle product: from inception to shipping;
      from web and backend development to database and cloud system administration. </p>

      <h3> Here are some ideas about what we can work together </h3>
      <div >

      <p> Your <b> landing page </b> as a blazing fast elegant webpage that clearly sells your message to your audience </p>

      <p> From an <b> MVP </b> to the <b> full product </b> including an <b> app/web, backend, database, cloud deploy, monitoring </b> and whatever you can think of. </p>

      <p> Cross-platform <b> mobile and desktop apps </b> solutions we can ship with <b> half of cost and code</b>. Native should be considered too!</p>

      <p>Custom <b> consulting </b> because sometimes you need an other point of view and sometimes you don't need to reinvent the wheel.
      For that, an existing solution may fit your needs, or not. Let's check it together! </p>

      <p><b> Sky is the limit 🚀 </b></p>

      <small> <i> Some buzzwords (one is a Pokemon): Javascript (Vue, React, React Native, Node), Python (Flask, Big Data), Java (Android, Spring, Hibernate), Postgre, Mongo, Pikachu, Terraform, Ansible, AWS...</i> </small>
      </div>

    </div>
    <hr class="separator">
    <div>
      <h2 class="text-center"> How we're going to achieve it </h2>
      <p class="text-center">
        When doing a project I like to work in a <b> transparent, efficient and methodic </b> way.</p>

      <p>
         I think the success of a project is related to the communication of both parties,
        and that a successful communication leads to a cheaper and higher quality project: a totally <b>win-win</b>.
      </p>
      <p>
        <b> I code, you own </b> mentality: no unneeded maintenance fees, you can hire anyone else if you want, no tricks on that.
      </p>
      <p>
        That's why I recommend using an Agile like method, doing multiple short cycles of: <b> plan, develop, feedback, and deploy </b> phases during
        the project's life span.
      </p>
      <p>
        But all starts with an initial conversation where we understand your project needs, we define requirements and we prepare for:
      </p>

      <div style="display:flex; flex-wrap: wrap">
        <div style="flex: 1; min-width: 200px" class="text-center" >
          <h3> 1. Plan 📅 </h3>
          <p> Define top priorities </p>
          <p> Gather information </p>
          <p> Agree on a schedule </p>
        </div>
        <div style="flex: 1; min-width: 200px" class="text-center">
          <h3> 2. Develop 💻 </h3>
          <p> Code </p>
          <p> Talk if needed </p>
          <p> Code </p>
        </div>
        <div style="flex: 1; min-width: 200px" class="text-center">
          <h3> 3. Feedback 🎙️</h3>
          <p> Easy and fast follow up </p>
          <p> What has to change </p>
          <p> What've we learnt </p>
        </div>
        <div style="flex: 1; min-width: 200px" class="text-center">
          <h3> 4. Deploy 🌈</h3>
          <p> Minor changes </p>
          <p> Test & deploy </p>
          <p> Back to <b> Plan </b></p>
        </div>
      </div>
    </div>

    </div>
    <div class="text-center" style="margin-top: 15px;">
      <a
        style="border: 1px solid black; padding: 10px; border-radius: 5px; text-decoration: none"
        class="text-center"
        href="https://www.linkedin.com/in/marcospr/" target="_blank" > Let's talk</a>.
    </div>
    <hr class="separator">
    <div class="text-center">
      <p>I also write the following 0 spam newsletter (promise) where a key idea is discussed and a few interesting links are shared in every email:</p>
      <iframe src="https://marcosperezrubio.substack.com/embed" width="360" height="280" style="border:1px solid #EEE; background:white;" frameborder="0" scrolling="no"></iframe>
    </div>
    <div class="text-right" style="margin-top: 20px;">
      <router-link :to="{name: 'Privacy'}">
        <p style="color: gray; text-decoration: none">  <u> Privacy policy </u> </p>
      </router-link>
    </div>
    </div>

</template>

<script>

const IMAGES = [
  '/face_bw-sm.webp',
  '/greek-profile.jpg',
  '/roma-profile.jpg'
]

export default {
  name: 'bio',
  data () {
    return {
      imgUrl: IMAGES[0],
      availableImages: IMAGES,
      timeToTransition: 30 * 1000
    }
  },
  mounted () {
    /*
    setInterval(() => {
      const currentImgIndex = this.availableImages.indexOf(this.imgUrl)
      const currentNbrOfImages = this.availableImages.length
      const nextImageIndex = (currentImgIndex + 1) % currentNbrOfImages
      this.imgUrl = this.availableImages[nextImageIndex]
    }, this.timeToTransition)
    */
  }
}
</script>

<style lang="scss">
</style>
